'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var consts = require('../../consts.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"optgroup":"select__optgroup_tbsps","label":"select__label_tbsps","size-64":"select__size-64_tbsps","size-72":"select__size-72_tbsps"};
require('./index.css')

var Optgroup = function (_a) {
    var children = _a.children, className = _a.className, label = _a.label, _b = _a.size, size = _b === void 0 ? 48 : _b;
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement("div", { className: cn__default.default(styles.optgroup, className, styles[consts.SIZE_TO_CLASSNAME_MAP[size]]) },
            React__default.default.createElement("span", { className: styles.label }, label)),
        children));
};

exports.Optgroup = Optgroup;
